// GENERATED FILE - DO NOT MODIFY

export enum GetLocationServicesSortColumnDto {
    Name = "Name",
    Email = "Email",
}